<!-- Page Content Customers Block-->
<section id="reviews">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 reviews-text" [ngClass]="{'text-left':business || chiefPage}">
        <h2 class="mt-4">Here's what customers have to say</h2>
        <p>For transparency and credibility we use Yelp & Google Reviews to collect testimonials from customers.</p>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4">
        <span class="yelp-review" data-review-id="ht14O5m1vuV9ks2_fyF5fQ" data-hostname="www.yelp.com">Read
          <a href="https://www.yelp.com/user_details?userid=cMNtJKUqbcdy8yncszdWRg" rel="nofollow noopener">Michelle S.</a>'s
          <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=ht14O5m1vuV9ks2_fyF5fQ" rel="nofollow noopener">review</a> of
          <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
          <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
        </span>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4">
        <span class="yelp-review" data-review-id="6-mDieVTUwxn279ZgFkJzw" data-hostname="www.yelp.com">Read
          <a href="https://www.yelp.com/user_details?userid=xNvyo7bzBz3MLUTvLuY0xw" rel="nofollow noopener">Gary L.</a>'s
          <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=6-mDieVTUwxn279ZgFkJzw" rel="nofollow noopener">review</a> of
          <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
          <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
        </span>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4">
        <span class="yelp-review" data-review-id="xwg1JTq6yo-kRtKp_QCPaQ" data-hostname="www.yelp.com">Read
          <a href="https://www.yelp.com/user_details?userid=K8xxw-Cw5fB8On4N8TRGOA" rel="nofollow noopener">Alex S.</a>'s
          <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=xwg1JTq6yo-kRtKp_QCPaQ" rel="nofollow noopener">review</a> of
          <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
          <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
        </span>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4">
        <span class="yelp-review" data-review-id="9TkUGVdUtGRze287bff73w" data-hostname="www.yelp.com">Read
          <a href="https://www.yelp.com/user_details?userid=xeTDGPsmD59Dh0YVhF4B9Q" rel="nofollow noopener">Paul V.</a>'s
          <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=9TkUGVdUtGRze287bff73w" rel="nofollow noopener">review</a> of
          <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
          <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
        </span>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-md-block">
        <span class="yelp-review" data-review-id="2LBn34cFja3i7lZ36a2ldA" data-hostname="www.yelp.com">Read
          <a href="https://www.yelp.com/user_details?userid=P_8KFAuJFtoSS1HLcWkX6w" rel="nofollow noopener">Nick M.</a>'s
          <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=2LBn34cFja3i7lZ36a2ldA" rel="nofollow noopener">review</a> of
          <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
          <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
        </span>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-md-block">
        <span class="yelp-review" data-review-id="OtyW8pa5PqPG9s4bWOuJUw" data-hostname="www.yelp.com">Read
          <a href="https://www.yelp.com/user_details?userid=O0sxDwUYSCu1IlRiqsRAgg" rel="nofollow noopener">Chris A.</a>'s
          <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=OtyW8pa5PqPG9s4bWOuJUw" rel="nofollow noopener">review</a> of
          <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
          <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
        </span>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-lg-block">
        <span class="yelp-review" data-review-id="MJYi7xk9gBuhGVBdfrK7JA" data-hostname="www.yelp.com">Read
          <a href="https://www.yelp.com/user_details?userid=PBJsZhpUNZgcfgym76HLXw" rel="nofollow noopener">Alisa N.</a>'s
          <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=MJYi7xk9gBuhGVBdfrK7JA" rel="nofollow noopener">review</a> of
          <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
          <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
        </span>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-lg-block">
        <span class="yelp-review" data-review-id="rZCIv3bciwa8MG7AMyTiUw" data-hostname="www.yelp.com">Read
          <a href="https://www.yelp.com/user_details?userid=lILtUhBdyN317SQlvxjEEw" rel="nofollow noopener">Charles T.</a>'s
          <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=rZCIv3bciwa8MG7AMyTiUw" rel="nofollow noopener">review</a> of
          <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
          <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
        </span>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-xl-block">
        <span class="yelp-review" data-review-id="8XHzdZ_F9fRwoTE1xy6ADQ" data-hostname="www.yelp.com">Read
          <a href="https://www.yelp.com/user_details?userid=oSY0JhvOYg2GxnkcW8MV3w" rel="nofollow noopener">Anthony G.</a>'s
          <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=8XHzdZ_F9fRwoTE1xy6ADQ" rel="nofollow noopener">review</a> of
          <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
          <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
        </span>
      </div>

      <ng-container *ngIf="chiefPage">
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-md-block">
          <span class="yelp-review" data-review-id="OHIBUk6yrJJKlqwjeVFcVQ" data-hostname="www.yelp.com">Read
            <a href="https://www.yelp.com/user_details?userid=3fZDxFENJ0c3CAZZNkYbJg" rel="nofollow noopener">Sue S.</a>'s
            <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=OHIBUk6yrJJKlqwjeVFcVQ" rel="nofollow noopener">review</a> of
            <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
            <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
          </span>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-lg-block">
          <span class="yelp-review" data-review-id="acdQv6cy-X2NqdwkP2TrrQ" data-hostname="www.yelp.com">Read
            <a href="https://www.yelp.com/user_details?userid=Z_yNfvupiAD-dYMAq3qsVw" rel="nofollow noopener">Megan R.</a>'s
            <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=acdQv6cy-X2NqdwkP2TrrQ" rel="nofollow noopener">review</a> of
            <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
            <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
          </span>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-lg-block">
          <span class="yelp-review" data-review-id="pMcTDw7UXt31HKjh8LIJ0Q" data-hostname="www.yelp.com">Read
            <a href="https://www.yelp.com/user_details?userid=8BNztLV40QvizqTt_2eMgA" rel="nofollow noopener">Stuart K.</a>'s
            <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=pMcTDw7UXt31HKjh8LIJ0Q" rel="nofollow noopener">review</a> of
            <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
            <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
          </span>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-lg-block">
          <span class="yelp-review" data-review-id="zQhzbc7jcyAFObbL9uyhsw" data-hostname="www.yelp.com">Read
            <a href="https://www.yelp.com/user_details?userid=ubxuaFtwX5_ym79-PXKT6A" rel="nofollow noopener">Cathy T.</a>'s
            <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=zQhzbc7jcyAFObbL9uyhsw" rel="nofollow noopener">review</a> of
            <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
            <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
          </span>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-lg-block">
          <span class="yelp-review" data-review-id="U8pFn8nnTV3UfLOxyFseuw" data-hostname="www.yelp.com">Read
            <a href="https://www.yelp.com/user_details?userid=tKmOblJbgFlY3GH6KJLodg" rel="nofollow noopener">Carl J.</a>'s
            <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=U8pFn8nnTV3UfLOxyFseuw" rel="nofollow noopener">review</a> of
            <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
            <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
          </span>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4 my-4 d-none d-xl-block">
          <span class="yelp-review" data-review-id="B8QblHGaHhbh73YfrnvJww" data-hostname="www.yelp.com">Read
            <a href="https://www.yelp.com/user_details?userid=l8za4N39nL9uLQz0HWeDqg" rel="nofollow noopener">Mark R.</a>'s
            <a href="https://www.yelp.com/biz/wholesale-flights-burlingame-3?hrid=B8QblHGaHhbh73YfrnvJww" rel="nofollow noopener">review</a> of
            <a href="https://www.yelp.com/biz/G742hppLv2tjm2uVz6kl6Q" rel="nofollow noopener">Wholesale Flights</a> on
            <a href="https://www.yelp.com" rel="nofollow noopener">Yelp</a>
          </span>
        </div>
      </ng-container>

      <app-script-inline [async]="true" [src]="'https://www.yelp.com/embed/widgets.js'"></app-script-inline>
    </div>
    <!-- /.row -->

  </div>
  <!-- /.container -->
</section>
